import { useEffect } from "react";

const usePageTitle = (title) => {
  useEffect(() => {
    const prev = document.title;
    document.title = title ? `${title} | ALMA VIVU` : "ALMA VIVU — Transition écologique en Corse";
    return () => { document.title = prev; };
  }, [title]);
};

export default usePageTitle;
